
import { Component, Mixins } from "vue-property-decorator";

@Component
export default class ProfessionFeatureAccessibleMixin extends Mixins() {
  get isProfessionFeatureEnable(): boolean {
    return this.$configuration.behavior.profession.feature.isEnable;
  }
}
